<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card v-if="tieneAcceso === false">
          <div slot="header">
            <strong>Criterios</strong>
          </div>
          <b-row>
            <b-col lg="12">
              <p>Acceso restringido</p>
            </b-col>
          </b-row>
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Filtros del Informe</strong>
          </div>
          <b-row>   
            <b-col sm="4">
                <b-form-group
                :label="crearLabel('Criterios', 'codcriterio', 'datosFormulario')"
                label-for="codcriterio"
              >
                <b-form-select
                  :options="valCriterios"
                  v-model="datosFormulario.codcriterio"
                  :disabled="campoBloqueado('codcriterio', 'datosFormulario')"
                ></b-form-select>

                <span class="error-validacion-campo">{{ mensajeValidacionCampo.codcriterio }}</span>
              </b-form-group>
            </b-col>
          </b-row>

          <div slot="footer">
                <div class="form-actions">
                    <el-row>
                            <el-col>
                                <b-button variant="primary" @click="buscar"><i class="fa fa-search"></i> Consultar</b-button>
                                <b-button variant="primary" @click="pre_insertar"><i class="fa fa-eraser"></i> Limpiar</b-button>
                            </el-col>     
                    </el-row>                
                </div>
            </div>            
        </b-card>

        <b-card v-if="tieneAcceso === true">
          <div slot="header">
            <strong>Criterios </strong>
          </div>
          <br>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
              <data-tables ref="refTable1"
                :data="data"
                name="table"
                class="table-responsive"
                :current-page.sync="pagina"
                :table-props="tableProps2"
                :filters="filters"
                :page-size="10"
                :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                layout="table"
              >
                <el-table-column
                  v-for="title in titles"
                  :min-width="title.minwidth" 
                  :prop="title.prop"
                  :label='title.label'
                  :key="title.label"
                  :align="title.align"
                  sortable="custom"
                  :formatter="formatter"
                  name="table"
                  class="table-responsive"
                ></el-table-column>
                <el-table-column label="Modificar" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-tooltip
                        v-for="button in customButtonsForRowModif(scope.row)"
                        :key="button.id"
                        :content="button.tooltip"
                        placement="top">
                        <el-button
                          type="text"
                          @click="button.handler"
                        >
                          <i v-bind:class="button.icon"></i>
                          {{ button.name }}
                        </el-button>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      
      </b-col>
    </b-row>

    <!-- Editar criterio -->
    <b-modal
      size="lg"
      title="Modificar"
      cancel-title="Cancelar"
      ok-title="Guardar"
      no-close-on-backdrop
      no-close-on-esc
      class="modal-success"
      v-model="modalEditar"
      @ok="modificar"
      @cancel="modalEditar = false"
    >
      
      <b-row>
        <b-col sm="3">  
          <b-form-group
            label="Criterio">
              <b-form-input
               id="descripcion"
               type="text"
               placeholder=""
               v-model="datosModificacion.descripcion"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col sm="5">  
          <b-form-group
            label="Valor">
              <b-form-input v-if="datosModificacion.tpdato === 'V'"
               id="valor"
               type="texto"
               placeholder=""
               v-model="datosModificacion.valor"
               @change="validarCampo('pkg_sinpp_mantencion', 'gcecriterio', $event, 'datosModificacion')">
            ></b-form-input>
              <b-form-input v-if="datosModificacion.tpdato === 'N'"
               id="valor"
               type="number"
               placeholder=""
               v-model="datosModificacion.valor"
               @change="validarCampo('pkg_sinpp_mantencion', 'gcecriterio', $event, 'datosModificacion')">
            ></b-form-input>
              <b-form-input v-if="datosModificacion.tpdato === 'D'"
               id="valor"
               type="date"
               placeholder=""
               v-model="datosModificacion.valor"
               @change="validarCampo('pkg_sinpp_mantencion', 'gcecriterio', $event, 'datosModificacion')">
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
    
  </div>
</template>
<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiCriterios from "@/components/services/apiCriterios";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';

import XLSX from "xlsx";

export default {
  name: "Criterios",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  components: {
    cSwitch
  },
  data: function() {
    return {
      tieneAcceso: true,
      es: es,
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      labelIcon: {
        dataOn: "\u2713",
        dataOff: "\u2715"
      },

      modalEditar: false,
      data: [],
      data2: [],

      titles: [
        {
          prop: "DESCRIPCION",
          label: "Descripción",
          align: "left",
          minwidth:'120'
        },
        {
          prop: "VALOR",
          label: "Valor",
          align: "right",
          minwidth:'120'
        },
        {
          prop: "USUMODIF",
          label: "Usuario Modificación",
          align: "center",
          minwidth:'120'
        },
        {
          prop: "FMODIF",
          label: "Fecha Modificación",
          align: "center",
          minwidth:'120'
        }
      ],

      mostrarFechas: true,
      datosFormulario: {
        codcriterio: '',
        criterio: '',
        descripcion: '',
        valor: '',
        usumodif: '',
        fmodif: '',
        tpdato: ''
      },

      datosModificacion: {
        criterio: "",
        descripcion: "",
        valor: "",
        usumodif: "",
        fmodif: "",
        tpdato: ""
      },
     
    
      valCriterios: [],

      value: null,

      mensajeValidacionCampo: {},

      tableProps2:{
          summaryMethod: this.totales,
          showSummary: false,
          maxHeight: 400,
          rowKey: "Siniestro"
      },
    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {
   modificar(){
      this.$Progress.start();
      console.log(this.datosModificacion.valor)
        apiCriterios
        .modificar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          process.env.VUE_APP_ID_SISTEMA,
          this.datosModificacion.criterio,
          this.datosModificacion.valor,
          this.datosModificacion.tpdato
        )
        .then(response => {
           this.$Progress.finish();
            this.crearNotificacion(
                "Modificar",
                "Datos guardados.",
                "success"
              );
            this.buscar();
        })
        .catch(error => {
          this.$Progress.finish();
          this.crearNotificacion("Error de sistema", error, "error");
          return;
        });
    }, 

    
    customButtonsForRow(row) {
          var botones = new Array();
          
          var obj = new Object();
            obj.tooltip = "Seleccionar";
            obj.id = 1;
            obj.name="Seleccionar";
            obj.icon = "";
            obj.type = "success";
            obj.handler= _ => {
                this.$session.start();
                this.datosFormulario.criterio = row.CRITERIO;
                this.datosFormulario.descripcion = row.DESCRIPCION;
                this.datosFormulario.valor = row.VALOR;
                this.data2 = [];
            }
            botones.push(obj);
          
          return botones;

    },

    customButtonsForRowModif(row) {
          var botones = new Array();
          
          var obj = new Object();
            obj.tooltip = "Modificar";
            obj.id = 1;
            obj.name="";
            obj.icon = "fa fa-edit";
            obj.type = "success";
            obj.handler= _ => {
                this.datosModificacion.criterio = row.CRITERIO;
                this.datosModificacion.descripcion = row.DESCRIPCION;
                this.datosModificacion.valor = row.VALOR;
                this.datosModificacion.tpdato = row.TPDATO;
                this.modalEditar = true;
                            }
            botones.push(obj);
          
          return botones;

    },

    enter: function(e) {
      e.preventDefault();
      if (e.keyCode === 13) {
        this.buscarBeneficiario();
      }
    },

    formatNumber(n) {
      console.log(n);
        n = String(n).replace(/\D/g, "");
        return n === '' ? n : Number(n).toLocaleString();
    },

  
    pre_insertar() {
      this.exportar = false;
      this.mensajeValidacionCampo = {};
      this.data = [];
      this.data2 = [];
      this.value = null;

      return apiCriterios
        .pre_insercion(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          process.env.VUE_APP_ID_SISTEMA
        )  
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          //Bloqueo usuario no valido
          if (response.data.args_out.usuarioval == 's'){
            this.tieneAcceso = true;
           }else{
             this.tieneAcceso = false;
           }
          
          var lista_data = response.data.res;
          for(var i = 0; i < lista_data.length; i++){
              this.datosFormulario.codcriterio = lista_data[i]["codcriterio"];
          }

          this.datosFormularioEstado = response.data.festado;

         //Carga lista de criterios
          var tiposCriterios = new Array();
          var lista_tipos_criterios = response.data.criterios;
          for(var i = 0; i < lista_tipos_criterios.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_criterios[i]["codcriterio"];
              obj.text = lista_tipos_criterios[i]["des_criterio"];
              tiposCriterios.push(obj);
          }
          this.valCriterios = tiposCriterios;
        
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    buscar() {
      this.$Progress.start();

      return apiCriterios
        .recuperar(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          process.env.VUE_APP_ID_SISTEMA,
          this.datosFormulario.codcriterio
        )
        .then(response => {
          this.data  = response.data.res;
           if (response.data.res.length > 0) {
                this.datosFormulario.criterio = response.data.res[0].CRITERIO;
                this.datosFormulario.descripcion = response.data.res[0].DESCRIPCION;
                this.datosFormulario.valor = response.data.res[0].VALOR;
                this.datosFormulario.usumodif = response.data.res[0].USUMODIF;
                this.datosFormulario.fmodif = this.convierteFecha(response.data.res[0].FMODIF);
                this.datosFormulario.tpdato = response.data.res[0].TPDATO;
           }
          this.pagina = this.paginaAnterior;
          this.$Progress.finish();
          
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    formatter(row, column) {
      
      if ((column.property == "FMODIF"
          ) && row[column.property]) {
        return this.configurarFechaLat(this.convierteFecha(row[column.property]));
      }
      else if ((column.property == "Monto Indemnizado en MonPol" ||
                column.property == "Parte Cubierta"
      ) && row[column.property]) {
        column.align = "is-right";
        if (row[column.property] == 0 || row[column.property] == "0"){
          return row[column.property];
        }else{
          return this.$numeral(row[column.property]).format('0,0.00');
        }
      }
      else if ((column.property == "Monto Impago" ||
                column.property == "Casos Excepcionados"
               ) && row[column.property]){
        column.align = "is-right";
        if (row[column.property] == 0 || row[column.property] == "0"){
          return row[column.property];
        }else{
          return this.$numeral(row[column.property]).format();
        }
      }
      else {
        return row[column.property];
      }
    },
    
    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },
  },
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.label-blanco{
  color: #fff;
}
</style>
